import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
    status: 'idle' | 'pending' | 'translating' | 'processing' | 'completed' | 'failed' | 'disconnected';
    progress?: number;
    stage?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ status, progress, stage }) => {
    // 动态计算假的进度条百分比
    let percent = progress;

    if (percent === undefined) {
        if (status === 'pending') percent = 10;
        else if (status === 'translating') percent = 60;
        else if (status === 'completed') percent = 100;
        else if (status === 'failed') percent = 100;
        else percent = 0;
    }

    let icon = '🔄';
    let className = 'progress-bar-fill';

    if (status === 'completed') {
        className += ' completed';
        icon = '✅';
    } else if (status === 'failed') {
        className += ' failed';
        icon = '❌';
    } else if (status === 'translating') {
        className += ' translating';
    }

    if (status === 'idle') return null;

    return (
        <div className="progress-container">
            <div className="progress-bar-bg">
                <div
                    className={className}
                    style={{ width: `${percent}%` }}
                />
            </div>
            <div className="progress-info">
                <span className="progress-stage">
                    {icon} {stage || '处理中...'}
                </span>
                <span className="progress-percent">
                    {(percent || 0).toFixed(0)}%
                </span>
            </div>
        </div>
    );
};

export default ProgressBar;
